/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, OnInit } from '@angular/core';
import { State } from '@core/store';
import * as DepartmentsActions from '@departments/store/departments.actions';
import { getDepartments, getIsDepartmentActionPending } from '@departments/store/departments.selectors';
import { Store } from '@ngrx/store';
import { Department } from '@shared/models';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-departments',
    templateUrl: './departments.component.html',
    styleUrls: ['./departments.component.scss'],
    standalone: false
})
export class DepartmentsComponent implements OnInit {
  readonly tableColumns = [
    'sortOrder',
    'name',
    'color',
    'opacity',
    'holds',
    'people',
    'vehicles',
    'actions'
  ];
  departments$: Observable<Department[]>;
  actionPending$: Observable<boolean>;

  constructor(private store: Store<State>) { }

  ngOnInit(): void {
    this.departments$ = this.store.select(getDepartments);
    this.actionPending$ = this.store.select(getIsDepartmentActionPending);
    this.store.dispatch(new DepartmentsActions.LoadDepartments());
  }

  editDepartment(departmentId?: string): void {
    this.store.dispatch(new DepartmentsActions.EditDepartment(departmentId));
  }

  deleteDepartment(departmentId: string): void {
    this.store.dispatch(new DepartmentsActions.DeleteDepartment(departmentId));
  }

  /**
   * Solange aktive Personen oder Fahrzeuge zugeordnet sind, wird das Loeschen
   * serverseitig abgelehnt - der Button bleibt deshalb gesperrt, statt in einen
   * Fehler zu laufen.
   */
  canBeDeleted(department: Department): boolean {
    return 0 === (department.activeDriverCount ?? 0)
      && 0 === (department.activeVehicleCount ?? 0);
  }
}
